import deglawySVG from './images/deglawy';
import arrowLeftSVG from './images/arrow-left';
import arrowRightSVG from './images/arrow-right';
import goldenStarSvg from './images/goldenStar';
import goldenCrownSvg from './images/crown';

interface ImagesInterface {
  calendar: string;
  info: string;
  placeHolder: string;
  rectangle: string;
  typeFour: string;
  typeOne: string;
  typeThree: string;
  typeTwo: string;
  deglawy: JSX.Element;
  activeTrophy: string;
  inActiveTrophy: string;
  csvPlaceholder: string;
  xlsxPlaceHolder: string;
  phonePreview: string;
  emptyShield: string;
  backSpace: string;
  clubOccupancyPlaceholder: string;
  star: string;
  arrowLeft: JSX.Element;
  arrowRight: JSX.Element;
  arrow: string;
  noPointsImage: string;
  goldenStar: JSX.Element;
  goldenCrown: JSX.Element;
}

export const images: ImagesInterface = {
  calendar: require('./images/calendar.png'),
  info: require('./images/info.png'),
  placeHolder: require('./images/placeholder.png'),
  rectangle: require('./images/Rectangle.png'),
  typeFour: require('./images/typeFour.png'),
  typeOne: require('./images/typeOne.png'),
  typeThree: require('./images/typeThree.png'),
  typeTwo: require('./images/typeTwo.png'),
  deglawy: deglawySVG,
  activeTrophy: require('./images/active trophy.png'),
  inActiveTrophy: require('./images/inactive trophy.png'),
  csvPlaceholder: require('./images/csv-placeholder.png'),
  xlsxPlaceHolder: require('./images/xlsx.png'),
  phonePreview: require('./images/phonePreview.svg'),
  emptyShield: require('./images/emptyShield.png'),
  backSpace: require('./images/backspace.png'),
  clubOccupancyPlaceholder: require('./images/clubOccupancyPlaceholder.png'),
  star: require('./images/star.png'),
  arrowLeft: arrowLeftSVG,
  arrowRight: arrowRightSVG,
  arrow: require('./images/arrow.png'),
  noPointsImage: require('./images/nopoints.png'),
  goldenStar: goldenStarSvg,
  goldenCrown: goldenCrownSvg,
};
